import React from "react";
import PrayTimesTable from "./PrayTimesTable";
import App from "../App";

class Proxy extends React.Component {
    render() {
        return(
            <PrayTimesTable {...this.props}/>
        )
    }
}
export default Proxy;